import { t } from "i18next";
import React from "react";
import { CarouselWidget } from "./MinorComponents/CarouselWidget.component";
import { useGetPreviewWidgetItemsQuery } from "../../queries/widgets";
import { CommonWidgetContainer } from "../Commons/CommonWidgetContainer.styles";
import { WidgetSkeleton } from "../WidgetSkeleton/WidgetSkeleton.component";


export const PreviewWidget: React.FC<{ enabled?: boolean }> = ({ enabled = true }) => {
  const { data: items, isLoading } = useGetPreviewWidgetItemsQuery({ enabled });

  if (isLoading) {
    return (
      <CommonWidgetContainer>
        <WidgetSkeleton />
      </CommonWidgetContainer>
    );
  }

  if((items?.corporateRedactionalActivityObjects||[]).length > 0){
    return (
      <CommonWidgetContainer component="section" aria-label={ t("preview_widget_label") }>
        <CarouselWidget  items={ items }/>
      </CommonWidgetContainer>
    );
  }

};
